/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckDocumentProvisionMethod } from './PaxCheckDocumentProvisionMethod';
import {
    PaxCheckDocumentProvisionMethodFromJSON,
    PaxCheckDocumentProvisionMethodFromJSONTyped,
    PaxCheckDocumentProvisionMethodToJSON,
    PaxCheckDocumentProvisionMethodToJSONTyped,
} from './PaxCheckDocumentProvisionMethod';
import type { PaxCheckAllowedDocumentFormat } from './PaxCheckAllowedDocumentFormat';
import {
    PaxCheckAllowedDocumentFormatFromJSON,
    PaxCheckAllowedDocumentFormatFromJSONTyped,
    PaxCheckAllowedDocumentFormatToJSON,
    PaxCheckAllowedDocumentFormatToJSONTyped,
} from './PaxCheckAllowedDocumentFormat';
import type { PaxCheckDocumentMrzConfiguration } from './PaxCheckDocumentMrzConfiguration';
import {
    PaxCheckDocumentMrzConfigurationFromJSON,
    PaxCheckDocumentMrzConfigurationFromJSONTyped,
    PaxCheckDocumentMrzConfigurationToJSON,
    PaxCheckDocumentMrzConfigurationToJSONTyped,
} from './PaxCheckDocumentMrzConfiguration';
import type { PaxCheckDocumentSidesExpectation } from './PaxCheckDocumentSidesExpectation';
import {
    PaxCheckDocumentSidesExpectationFromJSON,
    PaxCheckDocumentSidesExpectationFromJSONTyped,
    PaxCheckDocumentSidesExpectationToJSON,
    PaxCheckDocumentSidesExpectationToJSONTyped,
} from './PaxCheckDocumentSidesExpectation';
import type { PaxCheckDocumentSidesConfiguration } from './PaxCheckDocumentSidesConfiguration';
import {
    PaxCheckDocumentSidesConfigurationFromJSON,
    PaxCheckDocumentSidesConfigurationFromJSONTyped,
    PaxCheckDocumentSidesConfigurationToJSON,
    PaxCheckDocumentSidesConfigurationToJSONTyped,
} from './PaxCheckDocumentSidesConfiguration';

/**
 * Describes a document which can be used to resolve checklist item
 * @export
 * @interface PaxCheckAllowedDocument
 */
export interface PaxCheckAllowedDocument {
    /**
     * Type of document
     * @type {string}
     * @memberof PaxCheckAllowedDocument
     */
    type: string;
    /**
     * 
     * @type {PaxCheckAllowedDocumentFormat}
     * @memberof PaxCheckAllowedDocument
     */
    documentFormat: PaxCheckAllowedDocumentFormat;
    /**
     * Title (localised)
     * @type {string}
     * @memberof PaxCheckAllowedDocument
     */
    title: string;
    /**
     * Description (localised)
     * @type {string}
     * @memberof PaxCheckAllowedDocument
     */
    description?: string | null;
    /**
     * Allowed provision methods (MANUAL, SCAN, UPLOAD)
     * @type {Array<PaxCheckDocumentProvisionMethod>}
     * @memberof PaxCheckAllowedDocument
     */
    provisionMethods: Array<PaxCheckDocumentProvisionMethod>;
    /**
     * 
     * @type {PaxCheckDocumentSidesConfiguration}
     * @memberof PaxCheckAllowedDocument
     */
    sidesConfiguration: PaxCheckDocumentSidesConfiguration;
    /**
     * 
     * @type {PaxCheckDocumentSidesExpectation}
     * @memberof PaxCheckAllowedDocument
     */
    sidesExpectation: PaxCheckDocumentSidesExpectation;
    /**
     * 
     * @type {PaxCheckDocumentMrzConfiguration}
     * @memberof PaxCheckAllowedDocument
     */
    sideWithMrz: PaxCheckDocumentMrzConfiguration;
    /**
     * If true, document of this type can be applied to multiple pax sessions with a single apply (ie using multipax-apply-document/file)
     * @type {boolean}
     * @memberof PaxCheckAllowedDocument
     */
    multipaxResolutionSupported: boolean;
    /**
     * Sample image URL (optional)
     * @type {string}
     * @memberof PaxCheckAllowedDocument
     */
    sampleImageSrc?: string | null;
    /**
     * Document country code (iso alpha-3) - can be EURO
     * @type {string}
     * @memberof PaxCheckAllowedDocument
     */
    country?: string | null;
    /**
     * Whether to expect long processing on the backend - allows to show user a warning
     * @type {boolean}
     * @memberof PaxCheckAllowedDocument
     */
    expectLongProcessing: boolean;
    /**
     * Which page of the document is relevant - pass to /apply
     * @type {number}
     * @memberof PaxCheckAllowedDocument
     */
    pageIndexToProcess?: number | null;
}



/**
 * Check if a given object implements the PaxCheckAllowedDocument interface.
 */
export function instanceOfPaxCheckAllowedDocument(value: object): value is PaxCheckAllowedDocument {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('documentFormat' in value) || value['documentFormat'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('provisionMethods' in value) || value['provisionMethods'] === undefined) return false;
    if (!('sidesConfiguration' in value) || value['sidesConfiguration'] === undefined) return false;
    if (!('sidesExpectation' in value) || value['sidesExpectation'] === undefined) return false;
    if (!('sideWithMrz' in value) || value['sideWithMrz'] === undefined) return false;
    if (!('multipaxResolutionSupported' in value) || value['multipaxResolutionSupported'] === undefined) return false;
    if (!('expectLongProcessing' in value) || value['expectLongProcessing'] === undefined) return false;
    return true;
}

export function PaxCheckAllowedDocumentFromJSON(json: any): PaxCheckAllowedDocument {
    return PaxCheckAllowedDocumentFromJSONTyped(json, false);
}

export function PaxCheckAllowedDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckAllowedDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'documentFormat': PaxCheckAllowedDocumentFormatFromJSON(json['document_format']),
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'provisionMethods': ((json['provision_methods'] as Array<any>).map(PaxCheckDocumentProvisionMethodFromJSON)),
        'sidesConfiguration': PaxCheckDocumentSidesConfigurationFromJSON(json['sides_configuration']),
        'sidesExpectation': PaxCheckDocumentSidesExpectationFromJSON(json['sides_expectation']),
        'sideWithMrz': PaxCheckDocumentMrzConfigurationFromJSON(json['side_with_mrz']),
        'multipaxResolutionSupported': json['multipax_resolution_supported'],
        'sampleImageSrc': json['sample_image_src'] == null ? undefined : json['sample_image_src'],
        'country': json['country'] == null ? undefined : json['country'],
        'expectLongProcessing': json['expect_long_processing'],
        'pageIndexToProcess': json['page_index_to_process'] == null ? undefined : json['page_index_to_process'],
    };
}

export function PaxCheckAllowedDocumentToJSON(json: any): PaxCheckAllowedDocument {
    return PaxCheckAllowedDocumentToJSONTyped(json, false);
}

export function PaxCheckAllowedDocumentToJSONTyped(value?: PaxCheckAllowedDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'document_format': PaxCheckAllowedDocumentFormatToJSON(value['documentFormat']),
        'title': value['title'],
        'description': value['description'],
        'provision_methods': ((value['provisionMethods'] as Array<any>).map(PaxCheckDocumentProvisionMethodToJSON)),
        'sides_configuration': PaxCheckDocumentSidesConfigurationToJSON(value['sidesConfiguration']),
        'sides_expectation': PaxCheckDocumentSidesExpectationToJSON(value['sidesExpectation']),
        'side_with_mrz': PaxCheckDocumentMrzConfigurationToJSON(value['sideWithMrz']),
        'multipax_resolution_supported': value['multipaxResolutionSupported'],
        'sample_image_src': value['sampleImageSrc'],
        'country': value['country'],
        'expect_long_processing': value['expectLongProcessing'],
        'page_index_to_process': value['pageIndexToProcess'],
    };
}

